import { useState } from 'react'

import arrowIcon from '@assets/images/arrow_up-icon.svg'
import copyIcon from '@assets/images/copy-icon.svg'
import trashIcon from '@assets/images/trash-icon.svg'

import { SwitchButton } from '@components/SwitchButton'

import {
  ArrowDownImg,
  ArrowImg,
  ArrowUpImg,
  ButtonArrowContainer,
  ButtonContainer,
  CardContainer,
  CardContent,
  CardHeaderContainer,
  CardHeaderTitle,
  Footer,
  SwitchContainer,
  SwitchLabel,
} from './FormFieldCard.styled'

export interface ActionsProps {
  onDelete: () => void
  onDuplicate?: () => void
  onUp?: () => void
  onDown?: () => void
  onChangeRequired?: (value: boolean) => void
  hideRequired?: boolean
}

export type FormFieldCardProps = {
  name?: string
  required?: boolean
  canUp?: boolean
  canDown?: boolean
  children: React.ReactNode
} & ActionsProps

export const FormFieldCard: React.FC<FormFieldCardProps> = ({
  name,
  onDelete,
  onDuplicate,
  onDown,
  onUp,
  onChangeRequired,
  canDown,
  canUp,
  children,
  required = false,
  hideRequired = false,
}: FormFieldCardProps) => {
  const [open, setOpen] = useState<boolean>(true)

  return (
    <CardContainer>
      <CardHeaderContainer>
        <ButtonArrowContainer
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()

            setOpen(!open)
          }}
        >
          <ArrowImg open={open} src={arrowIcon} />
        </ButtonArrowContainer>
        <CardHeaderTitle>{name}</CardHeaderTitle>
        {onDuplicate && (
          <ButtonContainer
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()

              onDuplicate()
            }}
          >
            <img src={copyIcon} />
          </ButtonContainer>
        )}
        <ButtonContainer
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()

            onDelete()
          }}
        >
          <img src={trashIcon} />
        </ButtonContainer>
        {onDown && (
          <ButtonContainer
            disabled={!canDown}
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()

              onDown()
            }}
          >
            <ArrowDownImg src={arrowIcon} />
          </ButtonContainer>
        )}
        {onUp && (
          <ButtonContainer
            disabled={!canUp}
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()

              onUp()
            }}
          >
            <ArrowUpImg src={arrowIcon} />
          </ButtonContainer>
        )}
      </CardHeaderContainer>
      {open && (
        <CardContent>
          {children}
          {!hideRequired && onChangeRequired && (
            <Footer>
              <SwitchContainer>
                <SwitchButton selected={required} onClick={() => onChangeRequired(!required)} />
                <SwitchLabel>Obligatoire</SwitchLabel>
              </SwitchContainer>
            </Footer>
          )}
        </CardContent>
      )}
    </CardContainer>
  )
}
